<div class="divDisplayContent">
  <div ng2FileDrop [ngClass]="{ 'drop-zone': true, 'over': hasBaseDropZoneOver }" (fileOver)="fileOverBase($event)"
    (onFileDrop)="fileDropOnZone($event)" [uploader]="uploaderPictures" class="dropZoneN2">
    <div class="dropZoneInitialText" #dropZoneInitialText>Déposer un fichier ici ...</div>
    <div *ngFor="let item of uploaderPictures.queue" class="itemNgFor">
      <div class="itemConteineur mat-elevation-z4">
        <div class="itemDropDelete">
          <!-- <mat-icon (click)="deleteElem(item)">close</mat-icon>   -->
          <span *ngIf="sendingPictureState == 1" style=" bottom: 2px;">
            <mat-progress-spinner diameter="18" mode="indeterminate"></mat-progress-spinner>
          </span>
          <span *ngIf="sendingPictureState == 2" style="  color : green; bottom: 2px;background-color : transparent">
            <mat-icon>done</mat-icon>
          </span>
          <span *ngIf="sendingPictureState == 0" style="  color : red; bottom: 2px; ; background-color : transparent">
            <mat-icon matTooltip="Erreur inconnu lors de l'envoi du fichier.">error_outline</mat-icon>
          </span>
        </div>
        <div [ngSwitch]="updateType(item?.file)">
          <div *ngSwitchCase="'audio'" class="itemDroped">
            <audio controls="controls" class="itemDroped">
              <source [src]=getBlob(item) [type]=getType(item)>
            </audio>
          </div>
          <div *ngSwitchCase="'video'" class="itemDroped">
            <video controls="controls">
              <source [src]=getBlob(item) [type]=getType(item)>
            </video>
          </div>
          <div *ngSwitchCase="'image'" class="itemDroped-image">
            <img [src]=getBlob(item) class="itemDroped-image-content" />
          </div>
          <div *ngSwitchCase="'office'" class="itemDropedOffice">
            <object [type]=getType(item) [data]=getBlob(item) class="itemDropedOffice"></object>
          </div>
          <div *ngSwitchCase="'noDisplayPlugin'" style="margin-top : -10px">
            <span class="dropItemEdgeText">Aperçu de fichier non disponible sous IE/Edge</span>
            <mat-icon class="dropItemTextMatIcon">attach_file</mat-icon>
          </div>
          <div *ngSwitchDefault>
            <object [type]=getType(item) [data]=getBlob(item) class="itemDroped"></object>
          </div>
        </div>
        <div class="itemDropTitle">{{item?.file?.name}}</div>
      </div>
    </div>
  </div>
  <div class="right-position">
    <button matButton="filled" class="secondary " matTooltip="Sélectionner un fichier"
      (click)="buttonClick($event)" [disabled]="sendingPictureState == 1">
      Sélectionner un fichier
      <mat-icon style="padding-right: 20px;">system_update_alt</mat-icon>
      <input type="file" style="display:none;" ng2FileSelect [uploader]="uploaderPictures" #inputTypeFile
        (change)="imgFileIn($event)" />
    </button>
  </div>
</div>